import { debounce } from 'lodash';
import moment from 'moment';
import MatchesOverviewTableItem from '../MatchesOverviewTableItem/MatchesOverviewTableItem.vue';
import { api, checkForUnauthorized } from '@/utils';

export default {
  name: 'MatchesOverviewTable',
  components: {
    MatchesOverviewTableItem,
  },
  props: {},
  data: () => ({
    formFields: {
      showAutomaticDossiers: {
        label: 'Show automatic dossier',
        name: 'automatic-dossier',
      },
      freeText: {
        label: 'Free text',
        name: 'free-text',
      },
    },

    loading: true,
    apiVersion: 1,
    page: 1,
    pageSize: 100,
    snackbar: false,
    snackbarText: String,
    headers: [
      { text: 'Match date', value: 'timestamp' },
      { text: 'Dossier 1', value: 'dossier1' },
      { text: 'Dossier 2', value: 'dossier2' },
      { text: 'Hoe', value: 'hoe' },
      { text: 'Score', value: 'score' },
      { text: 'Status', value: 'status' },
      { text: 'Merge', value: 'merge' },
    ],
    matches: [],
    searchInputs: {
      timestamp: '',
      dossier1: '',
      dossier2: '',
      hoe: '',
      score: '',
      status: ['Pending'],
      automatic: false,
      freeText: '',
    },
    hoeValues: ['Manual', 'Automatic'],
    statusValues: ['Pending', 'Merged', 'Rejected', 'Deprecated'],
    orderByField: 'Score',
    orderBy: 'Descending',
    automaticDossiersOptions: [{ text: 'All', value: null }, { text: 'Only automatic inputs', value: true }, { text: 'Contains manual inputs', value: false }],
  }),
  computed: {},
  methods: {
    fetchMatches: debounce(function fetch() {
      this.loading = true;
      this.matches = [];

      // Base URL
      let url = '/rule-engine/executions?';

      // Page and Pagesize
      url += `page=${this.page}&page-size=${this.pageSize}`;

      // Order by and direction
      url += `&order-by-field=${this.orderByField}&order-by=${this.orderBy}`;

      // Show automatic dossier
      if (this.searchInputs.automatic != null) {
        url += `&only-automated-inputs=${this.searchInputs.automatic}`;
      }

      if (this.searchInputs.timestamp !== '') {
        const timestampReference = moment(this.searchInputs.timestamp, 'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss.SSS');
        url += `&created-on=${encodeURIComponent(timestampReference.trim())}`;
      }

      // Score is an integer
      if (this.searchInputs.score !== '' && !Number.isNaN(this.searchInputs.score)) {
        url += `&score=${parseInt(this.searchInputs.score, 10)}`;
      }

      if (this.searchInputs.status.length > 0) {
        this.searchInputs.status.forEach((status) => {
          url += `&status=${encodeURIComponent(status.trim())}`;
        });
      }

      if (this.searchInputs.dossier1 !== '') {
        const dossier1 = `${this.searchInputs.dossier1}`;
        url += `&dossier-numbers=${encodeURIComponent(dossier1.trim())}`;
      }

      if (this.searchInputs.hoe !== '' && this.searchInputs.hoe !== undefined) {
        const mergedBy = `${this.searchInputs.hoe}`;
        url += `&merged-by=${encodeURIComponent(mergedBy.trim())}`;
      }

      if (this.searchInputs.dossier2 !== '') {
        const dossier2 = `${this.searchInputs.dossier2}`;
        url += `&dossier-numbers=${encodeURIComponent(dossier2.trim())}`;
      }

      if (this.searchInputs.freeText !== '') {
        const freeText = `${this.searchInputs.freeText}`;
        url += `&free-text=${encodeURIComponent(freeText.trim())}`;
      }

      api
        .get(url)
        .then((response) => {
          if (response.data.length <= 0) {
            this.snackbar = true;
            this.snackbarText = 'No (more) matches found.';

            if (this.page > 1) {
              this.page -= 1;
            }
          }

          this.matches = response.data;
          this.loading = false;
        })
        .catch((error) => {
          checkForUnauthorized(error);
          this.snackbar = true;
          this.snackbarText = `${error.response.status}: ${error.response.statusText}`;
          this.loading = false;
        });
    }, 500),
    clearFilter() {
      this.page = 1;
      this.pageSize = 20;
      this.searchInputs = {
        timestamp: '',
        dossier1: '',
        dossier2: '',
        hoe: '',
        score: '',
        status: 'Pending',
      };
    },
    filterDossier(dossier) {
      if (dossier.oldDossier) {
        this.searchInputs.dossier1 = dossier.dossierNummer;
        this.searchInputs.status = ['Pending'];
      } else {
        this.searchInputs.dossier2 = dossier.dossierNummer;
        this.searchInputs.status = ['Pending'];
      }
    },
    displayError(error) {
      checkForUnauthorized(error);
      this.snackbar = true;
      this.snackbarText = `${error.response.status}: ${error.response.statusText}`;
      this.loading = false;
    },
    triggerLoading() {
      this.loading = true;
    },
    fetchMoreMatches() {
      this.page += 1;
      this.fetchMatches();
    },
  },
  watch: {
    searchInputs: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchMatches();
      },
    },
  },
  created() {
    this.$eventHub.$on('fetch-matching--dossier', this.filterDossier);
    this.$eventHub.$on('fetch-matching', this.fetchMatches);
    this.$eventHub.$on('error-matching', this.displayError);
    this.$eventHub.$on('trigger-loading', this.triggerLoading);
    this.$eventHub.$on('clear-search-input', this.clearFilter);
  },
};
